import { Injectable } from '@angular/core';

import { TravelerPaxResponse } from '@pax/entities/traveler-pax';
import { User } from '@app/modules/core/interfaces/user';
import { TravelerTypes } from '@pax/entities/traveler-info';
import { PaxFormDataService } from '@pax/services/pax-form-data.service';

@Injectable()
export class PaxFormDateService {

  constructor(
    private paxFormDataService: PaxFormDataService,
  ) { }


  public defaultDate(paxTraveler: TravelerPaxResponse, user: User, travelerNumber: number, type: TravelerTypes): string[] {
    return this.paxFormDataService.hasPaxTravelerInfo(paxTraveler) ? this.dobFormatDate(paxTraveler.dob) :
      this.paxFormDataService.hasUserInfo(user, travelerNumber, type) && user.birth_date ?
        this.dobFormatDate(user.birth_date) : [];
  }

  private dobFormatDate(date: string): string[] {
    const TIME_ZONE_CONST = 'T';
    if (date) {
      const parts = date.split(TIME_ZONE_CONST);
      if (parts.length) {
        return parts[0].replace(new RegExp(/-/g), '/').split('/');
      } else {
        return date.replace(new RegExp(/-/g), '/').split('/');
      }
    } else return [];
  }

}
